<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
    <b-form v-if="demandeur && request" @submit.prevent="handleSubmit(send())">
      <!-- DEMANDEUR -->
      <div class="block-flat">
        <div class="header">
          <h3>Le demandeur</h3>
        </div>
        <div class="block-content">
          <fieldset>
            <legend>Identité</legend>
            <div class="text-center">
              <b-button @click="iAmDemandeur()" variant="primary"
                >Je suis le demandeur
              </b-button>
            </div>
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Statut :</label>
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12" class="form-with-label">
                  <b-form-radio-group
                    v-model="demandeur.nature"
                    :options="natures"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </div>
            <div id="par">
              <!-- DISPLAY CONDITIONNÉ -->
              <div class="form-group">
                <b-row>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">nom, prénom :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12" class="no-padding">
                    <b-row class="no-margin">
                      <!-- <b-col lg="2" md="3" sm="3" cols="12">
                        <b-form-select
                          class="send-api"
                          v-model="demandeur.title"
                          :options="titles"
                        ></b-form-select>
                      </b-col> -->
                      <b-col lg="6" md="9" sm="9" cols="12">
                        <b-form-input
                          v-model="demandeur.lastName"
                          placeholder="Merci de renseigner votre nom"
                          maxlength="100"
                        />
                      </b-col>
                      <b-col lg="6" md="12" sm="12" cols="12">
                        <b-form-input
                          v-model="demandeur.firstName"
                          placeholder="Merci de renseigner votre prénom"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- <div class="error text-center" id="error-title">
                                    Ces informations sont obligatoires, merci de les remplir
                                    convenablement.
                                  </div> -->
                </b-row>
              </div>
            </div>
            <div id="pro">
              <!-- NOT TO DISPLAY -->
              <div class="form-group">
                <b-row>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Dénomination :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-input
                      type="text"
                      v-model="demandeur.corporationName"
                      class="form-control send-api"
                      placeholder="Dénomination"
                      maxlength="100"
                    />
                    <!-- <div class="error" id="error-corporation_name">
                                        Cette information est obligatoire, merci de la remplir
                                        convenablement.
                                      </div> -->
                  </b-col>
                  <!-- <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">N° SIRET :</label>
                  </b-col> -->
                  <!-- <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-input
                      type="text"
                      v-model="demandeur.corporationSiret"
                      placeholder="N° SIRET"
                    /> -->
                  <!-- <div class="error" id="error-corporation_siret">
                                        Cette information est obligatoire, merci de la remplir
                                        convenablement.
                                      </div> -->
                  <!-- </b-col> -->
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Représenté par :</label>
                  </b-col>
                  <!--<b-col lg="2" md="2" sm="12" cols="12">
                                                      <label class='control-label'>Titre, nom, prénom :</label>
                                                  </b-col>-->
                  <!-- <b-col lg="10" md="9" sm="12" cols="12" class="no-padding">
                    <b-row>
                      <b-col lg="2" md="3" sm="3" cols="12">
                        <b-form-select
                          class="send-api"
                          v-model="demandeur.corporationAgentTitle"
                          :options="titles"
                        ></b-form-select>
                      </b-col> -->
                  <b-col lg="4" md="9" sm="9" cols="12">
                    <b-form-input
                      type="text"
                      v-model="demandeur.corporationAgent"
                      placeholder="Nom du représentant"
                      maxlength="100"
                    ></b-form-input>
                  </b-col>
                  <!-- </b-row>
                  </b-col> -->
                </b-row>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Coordonnées</legend>
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Numéro :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="number"
                    v-model="demandeur.addressNum"
                    placeholder="Numéro"
                  ></b-form-input>
                  <!-- <div class="error" id="error-address_num">
                                    Champ obligatoire et numérique
                                  </div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Extension :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="demandeur.addressExt"
                    placeholder="Extension"
                    maxlength="10"
                  ></b-form-input>
                  <!-- <div class="error" id="error-address_ext">
                                    Champ obligatoire
                                  </div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Type de voie :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="demandeur.addressType"
                    placeholder="Type de voie"
                    maxlength="100"
                  ></b-form-input>
                  <!-- <div class="error" id="error-address_type">
                                    Champ obligatoire
                                  </div> -->
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Nom de voie :</label>
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="demandeur.addressName"
                    placeholder="Nom de la voie"
                  ></b-form-input>
                  <!-- <div class="error" id="error-address_name">
                                    Champ obligatoire
                                  </div> -->
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Localité :</label>
                </b-col>
                <b-col lg="6" md="9" sm="12" cols="12">
                  <!--                      <b-form-input type='hidden' class='form-control send-api' id='address_city' v-model='address_city'></b-form-input>-->
                  <!--                      <b-form-input type='hidden' class='form-control send-api' id='address_insee' v-model='address_insee'></b-form-input>-->
                  <b-form-input
                    type="text"
                    v-model="demandeur.addressCity"
                    class="form-control autocomplete ville"
                    placeholder="Localité"
                  ></b-form-input>
                  <!-- <div class="error" id="error-address_city">
                                    Cette information est obligatoire, merci de la remplir
                                    convenablement.
                                  </div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Code postal :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="demandeur.addressPostalCode"
                    placeholder="Code postal"
                  ></b-form-input>
                  <!-- <div class="error" id="error-address_postal_code">
                                    Champ obligatoire
                                  </div> -->
                </b-col>
              </b-row>
            </div>
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">Téléphone :</label>
                </b-col>
                <b-col lg="3" md="9" sm="12" cols="12">
                  <b-form-input
                    v-model="demandeur.phone"
                    type="text"
                    placeholder="Numéro de téléphone"
                  ></b-form-input>
                  <!-- <div class="error text-center" id="error-phone">
                                    Ces informations sont obligatoires, merci de les remplir
                                    convenablement.
                                  </div> -->
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label"
                    >Indicatif pour le pays étranger :</label
                  >
                </b-col>
                <b-col lg="3" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="demandeur.phoneIndicative"
                    placeholder="Indicatif pays étranger"
                    maxlength="4"
                  ></b-form-input>
                  <!-- <div class="error text-center" id="error-phone_indicative">
                                    Ces informations sont obligatoires, merci de les remplir
                                    convenablement.
                                  </div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">Adresse email :</label>
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="demandeur.email"
                    placeholder="Adresse email"
                  ></b-form-input>
                  <!-- <div class="error text-center" id="error-email">
                                    Ces informations sont obligatoires, merci de les remplir
                                    convenablement.
                                  </div> -->
                </b-col>
              </b-row>
            </div>
            <div class="form-group">
              <b-row>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="form-with-label"
                >
                  <b-form-checkbox-group>
                    <b-form-checkbox
                      :disabled="add == false"
                      v-model="request.isbeneficiaire"
                      name="checkbox-1"
                      class="custom-control-inline"
                    >
                      Le Bénéficaire est différent du demandeur
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-col>
              </b-row>
            </div>

            <!-- isbeneficiaire -->
          </fieldset>
        </div>
      </div>
      <!-- BLOC BENEFICIAIRE DIFFERENT DU DEMANDEUR -->
      <div class="block-flat" v-if="request.isbeneficiaire">
        <div class="header">
          <h3>Si le bénéficiaire est différent du demandeur</h3>
        </div>
        <div class="block-content">
          <fieldset>
            <legend>Identité</legend>
            <!-- <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12">
                  <label class="control-label">Statut :</label>
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12" class="form-with-label">
                  <b-form-radio-group
                    v-model="beneficiaire.nature"
                    :options="natures"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </div> -->
            <div>
              <!-- DISPLAY CONDITIONNÉ -->
              <div class="form-group">
                <b-row>
                  <b-col lg="2" md="3" sm="12" cols="12">
                    <label class="control-label">nom, prénom :</label>
                  </b-col>
                  <b-col lg="10" md="10" sm="12" cols="12" class="no-padding">
                    <b-row class="no-margin">
                      <!-- <b-col lg="2" md="2" sm="4" cols="6">
                        <b-form-select
                          class="send-api"
                          v-model="beneficiaire.title"
                          :options="titles"
                        ></b-form-select>
                      </b-col> -->
                      <b-col lg="6" md="9" sm="9" cols="12">
                        <b-form-input
                          v-model="beneficiaire.lastName"
                          placeholder="Merci de renseigner votre nom"
                          maxlength="100"
                        />
                      </b-col>
                      <b-col lg="6" md="12" sm="12" cols="12">
                        <b-form-input
                          v-model="beneficiaire.firstName"
                          placeholder="Merci de renseigner votre prénom"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- <div class='error text-center' id='error-title'>Ces informations sont obligatoires,
                                                      merci de les remplir convenablement.
                                                  </div> -->
                </b-row>
              </div>
            </div>
            <!-- <div id="pro" v-else> -->
            <!-- NOT TO DISPLAY -->
            <!-- <div class="form-group">
                <b-row>
                  <b-col lg="2" md="2" sm="12" cols="12">
                    <label class="control-label">Dénomination :</label>
                  </b-col>
                  <b-col lg="4" md="4" sm="12" cols="12">
                    <b-form-input
                      :disabled="disabledCorp"
                      type="text"
                      v-model="beneficiaire.corporationName"
                      class="form-control send-api"
                      placeholder="Dénomination"
                      maxlength="100"
                    /> -->
            <!-- <div class='error' id='error-corporation_name'>Cette information est obligatoire,
                                                            merci de la remplir convenablement.
                                                        </div> -->
            <!-- </b-col>
                  <b-col lg="2" md="2" sm="12" cols="12">
                    <label class="control-label">N° SIRET :</label>
                  </b-col>
                  <b-col lg="4" md="4" sm="12" cols="12">
                    <b-form-input
                      :disabled="disabledCorp"
                      type="text"
                      v-model="beneficiaire.corporationSiret"
                      placeholder="N° SIRET"
                    /> -->
            <!-- <div class='error' id='error-corporation_siret'>Cette information est obligatoire,
                                                            merci de la remplir convenablement.
                                                        </div> -->
            <!-- </b-col>
                  <b-col
                    lg="12"
                    md="12"
                    sm="12"
                    cols="12"
                    style="margin-top: 15px"
                  >
                    <b>Représenté par :</b>
                  </b-col>
                  <b-col lg="2" md="2" sm="12" cols="12">
                    <label class="control-label">Titre, nom, prénom :</label>
                  </b-col>
                  <b-col lg="10" md="10" sm="12" cols="12" class="no-padding">
                    <b-row class="no-margin">
                      <b-col lg="2" md="2" sm="4" cols="6">
                        <b-form-select
                          class="send-api"
                          v-model="beneficiaire.corporationAgentTitle"
                          :options="titles"
                        ></b-form-select>
                      </b-col>
                      <b-col lg="10" md="10" sm="8" cols="6">
                        <b-form-input
                          type="text"
                          v-model="beneficiaire.corporationAgent"
                          id="corporation_agent"
                          class="form-control send-api"
                          placeholder="Nom du représentant"
                          maxlength="100"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div> -->
          </fieldset>
          <fieldset>
            <legend>Coordonnées</legend>
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Numéro :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="number"
                    v-model="beneficiaire.addressNum"
                    placeholder="Numéro"
                  ></b-form-input>
                  <!-- <div class='error' id='error-beneficiaire[address_num]'>Champ obligatoire et numérique -->
                  <!-- </div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Extension :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.addressExt"
                    placeholder="Extension"
                    maxlength="10"
                  ></b-form-input>
                  <!-- <div class='error' id='error-beneficiaire[address_ext]'>Champ obligatoire</div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Type de voie :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.addressType"
                    placeholder="Type de voie"
                    maxlength="100"
                  ></b-form-input>
                  <!-- <div class='error' id='error-beneficiaire[address_type]'>Champ obligatoire</div> -->
                </b-col>
                <!-- <b-col lg="12" md="12" sm="12" cols="12"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Nom de voie :</label>
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.addressName"
                    placeholder="Nom de la voie"
                  ></b-form-input>
                  <!-- <div class='error' id='error-beneficiaire[address_name]'>Champ obligatoire</div> -->
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Localité :</label>
                </b-col>
                <b-col lg="6" md="9" sm="12" cols="12">
                  <!--                        <input type='hidden' class='form-control send-api' id='beneficiaire[address_city]' name='beneficiaire[address_city]'/>-->
                  <!--                        <input type='hidden' class='form-control send-api' id='beneficiaire[address_insee]' name='beneficiaire[address_insee]'/>-->
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.addressCity"
                    class="form-control autocomplete ville"
                    placeholder="Localité"
                  ></b-form-input>
                  <!-- <div class='error' id='error-beneficiaire[address_city]'>Cette information est
                                                      obligatoire, merci de la remplir convenablement.
                                                  </div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Code postal :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.addressPostalCode"
                    placeholder="Code postal"
                  ></b-form-input>
                  <!-- <div class='error' id='error-beneficiaire[address_postal_code]'>Champ obligatoire</div> -->
                </b-col>
              </b-row>
            </div>
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">Téléphone :</label>
                </b-col>
                <b-col lg="3" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.phone"
                    placeholder="Numéro de téléphone"
                  ></b-form-input>
                  <!-- <div class='error text-center' id='error-beneficiaire[phone]'>Ces informations sont
                                                      obligatoires, merci de les remplir convenablement.
                                                  </div> -->
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label"
                    >Indicatif pour le pays étranger :</label
                  >
                </b-col>
                <b-col lg="3" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.phoneIndicative"
                    placeholder="Indicatif pays étranger"
                    maxlength="4"
                  ></b-form-input>
                  <!-- <div class='error text-center' id='error-beneficiaire[phone_indicative]'>Ces
                                                      informations sont obligatoires, merci de les remplir convenablement.
                                                  </div> -->
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">Adresse email :</label>
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12">
                  <b-form-input
                    type="text"
                    v-model="beneficiaire.email"
                    placeholder="Adresse email"
                  />
                  <!-- <div class='error text-center' id='error-beneficiaire[email]'>Ces informations sont
                                                      obligatoires, merci de les remplir convenablement.
                                                  </div> -->
                </b-col>
              </b-row>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="stepper-control">
        <b-button
          variant="white"
          @click="previous"
          class="btn marginRight-10 marginBottom-15"
        >
          <font-awesome-icon
            icon="caret-left"
            class="marginRight-5"
          ></font-awesome-icon>
          Précédent
        </b-button>
        <b-button type="submit" variant="primary" class="marginBottom-15">
          <span>Suivant</span>
          <font-awesome-icon
            icon="caret-right"
            class="marginLeft-5"
          ></font-awesome-icon>
        </b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

export default {
  // namespaced: true,
  props: ["add"],

  mounted() {
    this.$nextTick(function () {
      if (
        this.userConnected &&
        !this.userConnected.roles.includes("ROLE_USER") &&
        this.request &&
        this.request.operator
      ) {
        this.request.isbeneficiaire = true;
        this.beneficiaire.nature = "Entreprise";
        this.beneficiaire.corporationSiret = this.request.operator.code;
        this.beneficiaire.corporationName = this.request.operator.libelle;
        this.disabledCorp = true;
      }
    });
  },
  name: "Demandeur",
  data: () => ({
    disabledCorp: false,
  }),
  methods: {
    previous() {
      this.$emit("previous");
    },
    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (success == true) {
          this.$emit("submit");
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },
    ...Vuex.mapActions("Dossiers", ["setDossier"]),
    ...Vuex.mapActions("Perimeter", ["getPerimeters"]),
    ...Vuex.mapActions("Petitioner", ["setPetitioner", "setBeneficiary"]),
    iAmDemandeur() {
      this.demandeur.nature = this.userConnected.nature;
      this.demandeur.corporationName = this.userConnected.corporationName;
      this.demandeur.corporationAgent = this.userConnected.corporationAgent;
      this.demandeur.corporationSiret = this.userConnected.corporationSiret;
      this.demandeur.corporationAgentTitle =
        this.userConnected.corporationAgentTitle;
      this.demandeur.lastName = this.userConnected.lastName;
      this.demandeur.firstName = this.userConnected.firstName;
      this.demandeur.title = this.userConnected.title;
      this.demandeur.addressNum = this.userConnected.addressNum;
      this.demandeur.addressExt = this.userConnected.addressExt;
      this.demandeur.addressType = this.userConnected.addressType;
      this.demandeur.addressName = this.userConnected.addressName;
      this.demandeur.addressPostalCode = this.userConnected.addressPostalCode;
      this.demandeur.addressCity = this.userConnected.addressCity;
      this.demandeur.phone = this.userConnected.phone;
      this.demandeur.phoneIndicative = this.userConnected.phoneIndicative;
      this.demandeur.email = this.userConnected.email;
    },
  },

  computed: {
    demandeur: {
      get: function () {
        return this.petitioner;
      },
      set: function (newValue) {
        this.setPetitioner(newValue);
      },
    },
    beneficiaire: {
      get: function () {
        return this.beneficiary;
      },
      set: function (newValue) {
        this.setBeneficiary(newValue);
      },
    },
    request: {
      get: function () {
        return this.dossierSelected;
      },
      set: function (newValue) {
        this.setDossier(newValue);
      },
    },
    ...Vuex.mapGetters("User", ["natures", "titles"]),
    ...Vuex.mapGetters("Petitioner", ["beneficiary", "petitioner"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
};
</script>

<style scoped></style>
